<template>
    <div class="modal fade" id="cookieModalSettings" data-bs-backdrop="static" tabindex="-1" aria-labelledby="cookieModalSettingsLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="cookieModalSettingsLabel">Cookie settings on our site</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <h5>Required cookies</h5>
                            <p>These are necessary for our website to operate. They're set automatically and can't be switched off in our system. Whilst you can set your browser to block them, our site won't then work for you.</p>
                            <hr>
                        </div>
                        <form @submit.prevent="onSubmit" method="post" ref="cookieForm">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-10 col-sm-11">
                                        <h5>Performance cookies</h5>
                                    </div>
                                    <div class="col-2 col-sm-1">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input cookie-selector cursor-pointer" type="checkbox" name="performance" v-model="fields.performance" />
                                            <div class="text-danger" v-if="errors && errors.performance">{{ errors.performance[0] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <p>We use these to see how our site is being used, so we can improve the experience for all customers. The data is aggregated across all visitors, so is anonymous.</p>
                                <hr>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-10 col-sm-11">
                                        <h5>Advertising cookies</h5>
                                    </div>
                                    <div class="col-2 col-sm-1">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input cookie-selector cursor-pointer" type="checkbox" name="advertising" v-model="fields.advertising" />
                                            <div class="text-danger" v-if="errors && errors.advertising">{{ errors.advertising[0] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <p>We use these to tailor advertising to your interests - both on our site and other sites you visit. If you disable them, you'll still see adverts, they just won't be tailored to you.</p>
                                <hr>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-10 col-sm-11">
                                        <h5>Functional cookies</h5>
                                    </div>
                                    <div class="col-2 col-sm-1">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input cookie-selector cursor-pointer" type="checkbox" name="functional" v-model="fields.functional" />
                                            <div class="text-danger" v-if="errors && errors.functional">{{ errors.functional[0] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <p>We use these to improve our sites functionality and personalisation. They may be set by us or by third party providers whose services we use on our site.</p>
                            </div>
                            <div class="modal-footer">
                                <button v-if="cookiePage" type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                                <button v-else type="button" class="btn btn-custom-white" data-bs-target="#cookieBanner" data-bs-toggle="modal">Close</button>
                                <button type="submit" class="btn btn-primary" data-bs-dismiss="modal">Save changes</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { updateAnalyticsConsent } from '@frontendAssets/js/analytics.js';

export default {
    props: ['advertisingCookie', 'performanceCookie', 'functionalCookie', 'cookiePage'],
    data() {
        return {
            fields: {
                "performance": this.performanceCookie === 1 ? true : false,
                "advertising": this.advertisingCookie  === 1 ? true : false,
                "functional": this.functionalCookie  === 1 ? true : false,
            },
            errors: {},
        }
    },
    methods: {
        onSubmit() {
            this.errors = {};
            axios.post('/ajax/manage_cookie_settings', this.fields).then(response => {
                if(this.fields.advertising == true) {
                    updateAnalyticsConsent({
                        'ad_storage': 'granted',
                        'ad_user_data': 'granted',
                        'ad_personalization': 'granted'
                    });
                }
                else {
                    updateAnalyticsConsent({
                        'ad_storage': 'denied',
                        'ad_user_data': 'denied',
                        'ad_personalization': 'denied'
                    });
                }

                if(this.fields.performance == true) {
                    updateAnalyticsConsent({
                        'analytics_storage': 'granted',
                    });
                }
                else {
                    updateAnalyticsConsent({
                        'analytics_storage': 'denied',
                    });
                }

            }).catch(error => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                }
            });
        }
    }
}
</script>
